import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValidatorsProps, Response } from '@ui/src';
import {
  accountsGroupsApi,
  CreateGroupValidatorResponse,
} from '../services/groups';
import { Group } from '../../types';

export interface ChartsGroupsState {
  groupsValidation?: ValidatorsProps;
  groups?: Group[];
  panelIsOpen: boolean;
  selectedGroupIsLoading?: boolean;
  selectedGroup?: Group;
}

const initialState: ChartsGroupsState = {
  groups: undefined,
  panelIsOpen: false,
};

export const chartGroupsSlice = createSlice({
  name: 'chartGroups',
  initialState,
  reducers: {
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
    clearGroupsState: (state) => {
      state.groups = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        accountsGroupsApi.endpoints.getCreateGroupValidator.matchFulfilled,
        (state, action: PayloadAction<CreateGroupValidatorResponse>) => {
          state.groupsValidation = action.payload.data.createAccountGroupSchema;
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.getAccountsGroups.matchFulfilled,
        (state, action: PayloadAction<Response<Group>>) => {
          state.groups = action.payload.data.edges.map((item) => item.node);
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.createGroup.matchFulfilled,
        (state, action: PayloadAction<{ data: Group }>) => {
          const nextGroups = ([] as Group[]).concat(state.groups as Group[]);

          nextGroups.push(action.payload.data);

          state.groups = nextGroups;
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.getAccountsGroup.matchPending,
        (state) => {
          state.selectedGroupIsLoading = true;
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.getAccountsGroup.matchFulfilled,
        (state, action: PayloadAction<{ data: Group }>) => {
          state.selectedGroup = action.payload.data;
          state.selectedGroupIsLoading = false;
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.getAccountsGroup.matchRejected,
        (state) => {
          state.selectedGroupIsLoading = false;
        },
      )
      .addMatcher(
        accountsGroupsApi.endpoints.updateGroup.matchFulfilled,
        (state, action: PayloadAction<{ data: Group }>) => {
          const nextGroups = state.groups?.map((item) => {
            let result = { ...item };

            if (item.id === action.payload.data.id) {
              result = action.payload.data;
            }

            return result;
          });

          state.groups = nextGroups;
        },
      );
  },
});

export const { changePanelState, clearGroupsState } = chartGroupsSlice.actions;

export default chartGroupsSlice.reducer;
